import React, { useState, useEffect } from 'react'
import { Table, Flex, Space,Typography,} from 'antd';
import Main from '../../cpn/Main'
import { useKhmdListQuery, } from '../../store/BnsKeJiApi'
import Copy from '../../cpn/Copy'
import WorkWechatSelect from './WorkWechatSelect'
import ContactAddFriend from './ContactAddFriend'
import ContactAddFriendDel from './ContactAddFriendDel'
import { wechatList } from './wechatList'
import ContactDel from './ContactDel'
const { Paragraph, } = Typography;
function ContactListAddFriend() {    
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const [list, setList] = useState([]); 
    const {data,isSuccess} = useKhmdListQuery()
    const [gzwx_id,setGzwxId] = useState({value:'',name:'',phone:''})
    const [wechat,setWechat] = useState([])
    useEffect(() => {
        if(isSuccess&&data.Status==='success'){
            const arr = data.Result.map(item => {
                const {khmd_id:key,khmd_phone,khmd_content,khmd_ctime,khmd_uname,khmd_gzwx_id,khmd_gzwx_name,khmd_gzwx_phone,khmd_gzwx_time} = item;
                return item = {key,khmd_phone,khmd_content,khmd_ctime,khmd_uname,khmd_gzwx_id,khmd_gzwx_name,khmd_gzwx_phone,khmd_gzwx_time}
            })
            arr.sort((a, b) => {
                return new Date(b.khmd_ctime) - new Date(a.khmd_ctime)
            })
            setList(
                arr.filter(item => {
                    // If khmd_gzwx_time is falsy (undefined, null, or empty), include it
                    if (!item.khmd_gzwx_time) return true;
                    // Compare if khmd_gzwx_time is today
                    const today = new Date();
                    const itemDate = new Date(item.khmd_gzwx_time);
                    return (
                        itemDate.getFullYear() === today.getFullYear() &&
                        itemDate.getMonth() === today.getMonth() &&
                        itemDate.getDate() === today.getDate()
                    );
                })
            );
        // 统计今天每个微信的已加数量，并为 wechatList 的每个对象增加 num 字段（今天已加数量）
        const today = new Date();
        // 先统计每个微信 today 已加好友的数量
        const countPerWechat = {};
        data.Result.forEach(item => {
            if (item.khmd_gzwx_id && item.khmd_gzwx_time) {
                const itemDate = new Date(item.khmd_gzwx_time);
                if (
                    itemDate.getFullYear() === today.getFullYear() &&
                    itemDate.getMonth() === today.getMonth() &&
                    itemDate.getDate() === today.getDate()
                ) {
                    const wid = item.khmd_gzwx_id;
                    if (!countPerWechat[wid]) {
                        countPerWechat[wid] = 0;
                    }
                    countPerWechat[wid]++;
                }
            }
        });
        // 给 wechatList 每个对象增加 num 字段
        setWechat(
            wechatList.map(wx => ({
                ...wx,
                num: countPerWechat[wx.id] || 0
            }))
        );
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '2、复制手机号/微信号',
            dataIndex: 'khmd_phone',
            width: '10%',
            render: (text, record) => (
                <Space>
                    <Copy title={record.khmd_phone} />                    
                </Space>
            ),
        },       
        {
            title: '3、复制话术',
            width: '10%',
            render: (text, record) => (
                <Paragraph ellipsis={{rows:1}} style={{width:'100px'}}>
                    <Copy title='您好，我公司专门给旅行社定制财务软件，请通过一下，只留个联系方式，不会发广告。'/>  
                </Paragraph>     
            ),
        },
        {
            title: '4、操作',
            dataIndex: 'action',
            width: '10%',
            render: (text, record) => (
                <Space>
                    <ContactAddFriend khmd_id={record.key} gzwx_id={gzwx_id.value} gzwx_name={gzwx_id.name} gzwx_phone={gzwx_id.phone} eu_id={eu_id} eu_name={eu_name}/>     
                    <ContactAddFriendDel khmd_id={record.key}/>
                    <ContactDel khmd_id={record.key}/>
                </Space>
            ),  
        },
        {
            title: '加好友时间',
            width: '10%',
            dataIndex: 'khmd_gzwx_time',           
        },
        {
            title: '加好友微信昵称',
            width: '10%',
            dataIndex: 'khmd_gzwx_name',           
        },
        {
            title: '加好友手机号码',
            width: '10%',
            dataIndex: 'khmd_gzwx_phone',           
        },
        {
            title: '通过后的话术',
            width: '10%',
            dataIndex: 'khmd_gzwx_phone',           
            render: (_, record) => (
                <Paragraph ellipsis={{rows:1}} style={{width:'100px'}}>
                    <Copy title='您好，我是伯纳思软件的财务顾问，我公司专门为旅行社定制财务软件，如果贵旅行社有财务软件的需求，请随时联系我，谢谢！'/>  
                </Paragraph>     
            ),
        },
       
    ]    
    return (
        <Main selectedKeys={['/ContactListAddFriend']}  >            
            <Flex align='center' style={{marginTop:'10px'}}>
                <span style={{width:'160px',fontWeight:'bold',fontSize:'16px'}}>1、选择工作微信：</span>
                <WorkWechatSelect 
                    onChange={(value,name,phone) => {
                        setGzwxId({value,name,phone})
                    }}
                    wechat={wechat}
                />
            </Flex>
            <Table 
                dataSource={list} 
                columns={columns} 
                size='small'
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"10px"}}
            />
        </Main>
    )
}

export default ContactListAddFriend